import BaseRepository from "~/api/BaseRepository";
import type { User } from "@/stores/auth";
import type { FreelanceProfile } from "~/stores/userStore";
import type {$Fetch} from "nitropack";

export const UserRepository = (client: $Fetch) => ({
    ...BaseRepository(client)('/v1/users'),
    patchSelf: (payload: Partial<User>) => {
        return client(`/v1/users`, {
            method: 'PATCH',
            body: payload,
        });
    },
    createFreelance: async () => {
        return client(`/v1/freelances`, {
            method: 'POST',
            body: {},
            headers: {
                "Content-Type": "application/json",
            }
        });
    },
    uploadAvatar: async (file: File) => {
        const formData = new FormData();
        formData.append("picture", file);

        return client("/v1/freelances/profile", {
            method: "PATCH",
            body: formData,
        });
    },
    patchFreelance: (payload: Partial<FreelanceProfile>, companyId?: string) => {
        // Créer un FormData pour envoyer les données au format multipart/form-data
        const formData = new FormData();

        // Ajouter chaque champ du payload au FormData
        // Seuls les champs définis seront ajoutés
        Object.entries(payload).forEach(([key, value]) => {
            if (value !== undefined && value !== null) {
                if (Array.isArray(value)) {
                    // Pour les tableaux (comme les skills), on les joint avec des virgules
                    formData.append(key, value.join(','));
                } else if (value instanceof File) {
                    // Pour les fichiers, on les ajoute directement
                    formData.append(key, value);
                } else {
                    // Pour les autres types (string, number), on les convertit en string
                    formData.append(key, value.toString());
                }
            }
        });

        // Construire l'URL avec le company_id si fourni
        const url = companyId
            ? `/v1/freelances/profile?company_id=${companyId}`
            : "/v1/freelances/profile";

        // Envoyer la requête avec le FormData (pas besoin de spécifier Content-Type,
        // il sera automatiquement défini comme multipart/form-data avec la boundary)
        return client(url, {
            method: "PATCH",
            body: formData,
        });
    },
    getProfile: () => {
        return client("/v1/freelances/profile");
    },
    getNotificationSettings: () => {
        return client<{ mission_match_notifications_enabled: boolean }>(
            "/v1/freelances/profile/notification-settings",
        );
    },
    updateNotificationSettings: (payload: { mission_match_notifications_enabled: boolean }) => {
        return client<{ mission_match_notifications_enabled: boolean }>(
            "/v1/freelances/profile/notification-settings",
            {
                method: "PATCH",
                body: payload,
                headers: { "Content-Type": "application/json" },
            },
        );
    },
})